import { useCallback, useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import { useFormikContext } from 'formik'
import { t } from 'i18next'
import Dialog from 'src/components/shared/ui/Dialog/Dialog'
import { SearchIcon } from 'src/components/shared/ui/Icons'
import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import InputField from 'src/components/shared/ui/form/fields/InputField'
import LexnetIconButton from 'src/components/shared/ui/form/fields/LexnetIconButton'
import OrigenForm from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/components/Origen/components/forms/OrigenForm'
import RemoveInfoButton from 'src/components/views/EscritosLexnet/components/shared/components/RemoveInfoButton'
import useClearFormSections from 'src/components/views/EscritosLexnet/components/shared/hooks/useClearFormSections'
import { EscritosFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import {
  OrganoOrigenFormInitialvalues,
  OrganoOrigenFormValidations,
  OrganoOrigenFormValues
} from 'src/components/views/EscritosLexnet/components/shared/types/organoOrigenTypes'
import { FormField } from 'src/enums/Form'
import useNewModal from 'src/hooks/useModal'

const styles = {
  '& .MuiInputBase-input, & .MuiInputBase-root': {
    cursor: 'pointer'
  }
}

function OrganoOrigen(): JSX.Element {
  const [disabledRemoveButton, setDisabledRemoveButton] = useState(true)
  const { values, setFieldValue } = useFormikContext<EscritosFormValues>()
  const {
    isOpened: isOrganoModalOpened,
    close: closeOrganoModal,
    open: openOrganoModal
  } = useNewModal()
  const { clearOrganoOrigenFieldset, clearPartialProcedimientoSection } = useClearFormSections()
  const organoOrigen = values[FormField.ORGANO_ORIGEN]
  const procedimiento = values[FormField.PROCEDIMIENTO]

  useEffect(() => {
    if (organoOrigen) {
      if (procedimiento) {
        clearPartialProcedimientoSection(values)
      }
    }
    // eslint-disable-next-line
  }, [organoOrigen])

  const clearOrgano = useCallback(() => {
    clearOrganoOrigenFieldset()
    clearPartialProcedimientoSection(values)
    setDisabledRemoveButton(true)

    // eslint-disable-next-line
  }, [values])

  function getButtons() {
    return (
      <>
        <LexnetIconButton title={t('tooltips.buscar_organo_origen')} handleClick={openOrganoModal}>
          <SearchIcon />
        </LexnetIconButton>
        <RemoveInfoButton
          disabled={disabledRemoveButton}
          clear={clearOrgano}
          firstDialogMessage={t('dialog.message.remove_organo_origen')}
        />
      </>
    )
  }

  function formSubmit(values: OrganoOrigenFormValues) {
    setFieldValue(FormField.ORGANO_ORIGEN, values, false)
    setFieldValue(
      FormField.ORGANO_ORIGEN_DESCRIPCION,
      `${values[FormField.ORGANO_ORIGEN_ORGANO_JUDICIAL]?.nombre} DE ${values[
        FormField.ORGANO_ORIGEN_PARTIDO_JUDICIAL
      ]?.nombreMunicipio.toUpperCase()}`,
      false
    )
    setFieldValue(
      FormField.ORGANO_ORIGEN_ORDEN_DESCRIPCION,
      values[FormField.ORGANO_ORIGEN_ORDEN_JUDICIAL]?.descripcion
    )
    setDisabledRemoveButton(false)
    closeOrganoModal()
  }

  useEffect(() => {
    if (!organoOrigen) {
      setDisabledRemoveButton(true)
    }
  }, [organoOrigen])

  return (
    <>
      <FieldsetGroup legend={t('form.legend.organo_origen')} buttons={getButtons()} isSecondaryType>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={4} onClick={openOrganoModal}>
            <InputField
              id={FormField.ORGANO_ORIGEN_DESCRIPCION}
              label={t('form.field.organo')}
              readOnly
              required
              sx={styles}
            />
          </Grid>
          <Grid item xs={6} sm={4} onClick={openOrganoModal}>
            <InputField
              id={FormField.ORGANO_ORIGEN_ORDEN_DESCRIPCION}
              label={t('form.field.orden')}
              readOnly
              required
              sx={styles}
            />
          </Grid>
        </Grid>
      </FieldsetGroup>
      <Dialog
        title={t('form.dialog.title.organo_origen')}
        isOpen={isOrganoModalOpened}
        close={closeOrganoModal}
        cancel={() => ''}
        withForm
        validateFormik={false}
        formInitialValues={values[FormField.ORGANO_ORIGEN] || OrganoOrigenFormInitialvalues}
        formValidationScheme={OrganoOrigenFormValidations}
        formHandleSubmit={formSubmit}
      >
        <OrigenForm />
      </Dialog>
    </>
  )
}

export default OrganoOrigen
